'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Weekdays;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('./PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Weekdays(_ref) {
  var classNames = _ref.classNames,
      firstDayOfWeek = _ref.firstDayOfWeek,
      weekdaysLong = _ref.weekdaysLong,
      weekdaysShort = _ref.weekdaysShort,
      locale = _ref.locale,
      localeUtils = _ref.localeUtils,
      weekdayElement = _ref.weekdayElement;

  var days = [];
  for (var i = 0; i < 7; i += 1) {
    var weekday = (i + firstDayOfWeek) % 7;
    var elementProps = {
      key: i,
      className: classNames.weekday,
      weekday: weekday,
      weekdaysLong: weekdaysLong,
      weekdaysShort: weekdaysShort,
      localeUtils: localeUtils,
      locale: locale
    };
    var element = _react2.default.isValidElement(weekdayElement) ? _react2.default.cloneElement(weekdayElement, elementProps) : _react2.default.createElement(weekdayElement, elementProps);
    days.push(element);
  }

  return _react2.default.createElement(
    'div',
    { className: classNames.weekdays, role: 'rowgroup' },
    _react2.default.createElement(
      'div',
      { className: classNames.weekdaysRow, role: 'row' },
      days
    )
  );
}

Weekdays.propTypes = {

  classNames: _react.PropTypes.shape({
    weekday: _react.PropTypes.string.isRequired,
    weekdays: _react.PropTypes.string.isRequired,
    weekdaysRow: _react.PropTypes.string.isRequired
  }).isRequired,

  firstDayOfWeek: _react.PropTypes.number.isRequired,
  weekdaysLong: _react.PropTypes.arrayOf(_react.PropTypes.string),
  weekdaysShort: _react.PropTypes.arrayOf(_react.PropTypes.string),
  locale: _react.PropTypes.string.isRequired,
  localeUtils: _PropTypes2.default.localeUtils.isRequired,
  weekdayElement: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.func, _react.PropTypes.instanceOf(_react2.default.Component)])
};
//# sourceMappingURL=Weekdays.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-day-picker/lib/src/Weekdays.js
// module id = 1073
// module chunks = 0